"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var window_location_1 = require("../helpers/window-location");
var WindowLocationMock = /** @class */ (function (_super) {
    __extends(WindowLocationMock, _super);
    function WindowLocationMock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WindowLocationMock.prototype.assign = function (url) {
        this._url = url;
    };
    Object.defineProperty(WindowLocationMock.prototype, "href", {
        get: function () {
            return this._url;
        },
        set: function (value) {
            this._url = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocationMock.prototype, "pathname", {
        get: function () {
            var l = document.createElement('a');
            l.href = this._url;
            return l.pathname;
        },
        set: function (value) {
            var pathName = this.pathname;
            this._url = this._url.replace(pathName, value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocationMock.prototype, "hash", {
        get: function () {
            if (this._url === undefined || this._url === null || this._url === '') {
                return '';
            }
            var hashLocation = this._url.indexOf('#');
            if (hashLocation >= 0) {
                return this._url.substring(hashLocation + 1);
            }
            return '';
        },
        set: function (value) {
            if (value === undefined || value === null) {
                value = '';
            }
            if (this._url !== undefined && this._url !== null && this._url !== '') {
                var hashLocation = this._url.indexOf('#');
                if (hashLocation >= 0) {
                    this._url = this._url.substr(0, hashLocation + 1);
                    this._url += value;
                }
                else {
                    this._url = this._url + "#" + value;
                }
            }
            else {
                this._url = "#" + value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocationMock.prototype, "origin", {
        get: function () {
            return window.location.origin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocationMock.prototype, "hostname", {
        get: function () {
            return window.location.hostname;
        },
        set: function (value) {
            // do nothing
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocationMock.prototype, "port", {
        get: function () {
            return window.location.port;
        },
        set: function (value) {
            // do nothing
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WindowLocationMock.prototype, "protocol", {
        get: function () {
            return window.location.protocol;
        },
        set: function (value) {
            // do nothing
        },
        enumerable: true,
        configurable: true
    });
    return WindowLocationMock;
}(window_location_1.WindowLocation));
exports.WindowLocationMock = WindowLocationMock;
